export default function (chartData = {}) {
  // 计算总故障数和百分比
  const total = (chartData.safety || 0) + (chartData.income || 0) + (chartData.device || 0) + (chartData.other || 0);
  const data = [
    { value: chartData.safety || 0, name: '安全类' },
    { value: chartData.income || 0, name: '收益类' },
    { value: chartData.device || 0, name: '设备类' },
    { value: chartData.other || 0, name: '其他类' },
  ].map(item => ({
    ...item,
    pct: total > 0 ? Math.round((item.value / total) * 1000) / 10 : 0
  }));

  let option = {
    title: {
      text: '故障类型分析',
      left: 20,
      top: 10,
      textStyle: {
        color: '#000',
        fontSize: 16,
        fontWeight: 500,
        fontFamily: 'HarmonyOS Sans SC',
      }
    },
    color: ['#3E82EF', '#91BBFF', '#FF2E55', '#FCAD50', '#59D681'],
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {d}%'
    },
    series: [
      {
        type: 'pie',
        radius: ["68%", "72%"],
        center: ['55%', '50%'],
        silent: true,
        hoverAnimation: false,
        tooltip: { show: false },
        label: { show: false },
        labelLine: { show: false },
        data: [{
          name: '',
          value: 0,
          itemStyle: {
            normal: {
              color: "#E1E3FF"
            }
          }
        }]
      },
      {
        name: '故障类型',
        type: 'pie',
        center: ['55%', '50%'],
        radius: ['40%', '62%'],
        avoidLabelOverlap: true,
        minShowLabelAngle: 0,
        label: {
          show: true,
          position: 'outside',
          formatter: '{d}%',
          fontSize: 12
        },
        labelLine: {
          show: true,
          length: 8,
          length2: 6
        },
        data: data
      }
    ]
  };

  return option
}
